import { Button, CircularProgress, Tab, Tabs, Typography } from '@material-ui/core';
import { useUserApi } from 'hooks/useUserApi';
import { useState } from 'react';
import styles from './Profile.module.css';
import ConfirmDialog from 'components/common/ConfirmDialog/ConfirmDialog';
import { errorToast, successToast } from 'components/common/Toast/Toast';
import LoadIndicator from 'components/common/LoadIndicator/LoadIndicator';
import { useSelector } from 'react-redux';
import BillingCardsContainer from 'components/PhotoAdminComponents/Settings/Profile/BillingCards/BillingCardsContainer/BillingCardsContainer';
import ContactCardsContainer from 'components/PhotoAdminComponents/Settings/Profile/ContactCards/ContactCardsContainer/ContactCardsContainer';
import { useTranslation } from 'react-i18next';

const Profile = () => {
  const { t } = useTranslation();
  const [inProgress, setInProgress] = useState();
  const { deleteCurrentUser, userError } = useUserApi();

  const [inactiveDialogOpen, setInactiveDialogOpen] = useState(false);

  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);

  const [activeTab, setActiveTab] = useState(0);

  const showDialog = (status) => {
    if (status === 200 || userError) {
      successToast(t('profile.success'));
    } else {
      errorToast(t('profile.error'));
    }
  };

  const putInactiveWithDialog = async () => {
    setInProgress('delete');
    await deleteCurrentUser();
    setInactiveDialogOpen(false);
  };

  return (
    <div className={styles.mainContainer}>
      <Typography className={styles.title}>{t('profile.title')}</Typography>
      <Typography style={{ fontStyle: 'oblique' }}>
        #{t('common.username')}: {user?.username}
      </Typography>
      {user ? (
        <>
          <Tabs
            TabIndicatorProps={{
              style: { background: 'var(--primary-main)' }
            }}
            value={activeTab}>
            <Tab
              selected={activeTab === 0}
              label={t('profile.contactData')}
              onClick={() => {
                setActiveTab(0);
              }}
            />
            <Tab
              selected={activeTab === 1}
              label={t('profile.billingData')}
              onClick={() => {
                setActiveTab(1);
              }}
            />
          </Tabs>
          {activeTab === 0 && (
            <ContactCardsContainer
              user={user}
              inProgress={inProgress}
              setInProgress={setInProgress}
              showDialog={showDialog}
            />
          )}
          {activeTab === 1 && (
            <BillingCardsContainer
              user={user}
              inProgress={inProgress}
              setInProgress={setInProgress}
              showDialog={showDialog}
            />
          )}
          <div className={styles.deleteContainer}>
            <Button onClick={() => setInactiveDialogOpen(true)} variant='outlined' className={styles.buttonDelete}>
              {inProgress ? (
                <>
                  {t('common.inProgress')}
                  <CircularProgress style={{ marginLeft: '0.5rem' }} size={24} />
                </>
              ) : (
                t('profile.deleteAccount')
              )}
            </Button>
          </div>
        </>
      ) : (
        <LoadIndicator />
      )}
      <ConfirmDialog
        title={t('profile.deleteAccountWarning')}
        open={inactiveDialogOpen}
        onOk={() => {
          putInactiveWithDialog();
          setInactiveDialogOpen(false);
        }}
        onClose={() => setInactiveDialogOpen(false)}
        functionButtonColor={'var(--primary-success)'}
        functionButtonText={t('common.yes')}
        closeButtonText={t('common.no')}
        multipleButtons
      />
    </div>
  );
};

export default Profile;
